import { IntlShape } from 'react-intl';

import { MetricAnnotatorUser } from './types/responseTypes';

export const getAllAnnotatorsOption = (
  formatMessage: IntlShape['formatMessage']
): MetricAnnotatorUser => ({
  id: 'all-annotators',
  label: formatMessage({ id: 'metrics.dashboard.annotatorDropdown.allAnnotators' }),
});

export const METRICS_TAG = 'metrics';

export const BATCH_PROGRESS_TAB_OPTIONS = ['chart', 'table'];
